import { styled } from '@mui/material';
import { TabPanel } from '@mui/lab';

export const BusinessProfileTabsFormTabPanel = styled(TabPanel)({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  flex: 1,
});
